// main.js — application bootstrap. Resolves the session (so auth guards + first
// paint see the real user), then starts the SPA router over the route table.
// Deliberately tiny: behavior lives in the core (router/auth) and lazily-loaded
// page chunks.

import { bootstrapAuth } from './core/auth-context.js';
import { createRouter } from './core/router.js';
import { ROUTES } from './routes.js';

async function boot() {
  const outlet = document.getElementById('app');
  if (!outlet) return;

  // Resolve the current user before first render so guarded routes don't flash.
  // Fail-closed: errors leave user=null inside bootstrapAuth.
  await bootstrapAuth();

  createRouter({
    routes: ROUTES,
    outlet,
    notFound: { tag: 'pg-page-not-found', load: () => import('./pages/not-found.js') },
  }).start();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
